<dx-popup
[title]="task?.description || ''"
[(visible)]="visible"
(visibleChange)="onVisibleChange($event)"
contentTemplate="popup-content">
  <dxi-popup-toolbar-item location="after">
    <div *dxTemplate class="row">
      @if(moreLogs){
        <span class="progress"><i class="dx-icon-refresh"></i></span>
      }
    </div>
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popup-content'">
    @if(taskLogs && taskLogs.messages){
      <dx-data-grid
      [dataSource]="taskLogs.messages">
        <dxi-column dataField="date" [width]="250" cellTemplate="dateTemplate">
          <div *dxTemplate="let data of 'dateTemplate'">
              {{ data.data.date | date : 'medium' }}
          </div>
        </dxi-column>
        <dxi-column dataField="message" [cellTemplate]="'messageTemplate'">
          <div *dxTemplate="let data of 'messageTemplate'" class="wrap-text">
            {{data.value}}
          </div>
        </dxi-column>
        <dxi-column dataField="level"  [width]="100" cellTemplate="levelTemplate">
          <div *dxTemplate="let data of 'levelTemplate'">
            @switch(data.value) {
              @case(LogLevel.ERROR) {
                <span><i class="dx-icon-errorcircle log-status error"></i></span>
              }
              @case(LogLevel.INFO) {
                <span><i class="dx-icon-info log-status info"></i></span>
              }
              @case(LogLevel.WARN) {
                <span><i class="dx-icon-warning log-status warning"></i></span>
              }
              @default {
                <span><i class="dx-icon-help log-status info"></i></span>
              }
            }
          </div>
        </dxi-column>
      </dx-data-grid>
    }
  </div>
</dx-popup>
